import { Box, FormControl, Switch, Typography } from '@material-ui/core';
import React from 'react';

export const SwitchInput = ({ 
    label, 
    checked, 
    onChange 
}: { 
    label: string; 
    checked: boolean, 
    onChange: (value: boolean) => void 
}) => {
    return (
        <FormControl component="fieldset">
            <Box display="flex" alignItems="center">
                <Switch
                    checked={checked}
                    onChange={(_, value) => onChange(value)}
                    color="primary"
                />
                <Typography>{label}</Typography>
            </Box>
        </FormControl>
    );
}